import React from 'react';
import { t } from 'i18next';
import { ArrowLeft } from 'lucide-react';
import { RadixButton, RadixCard, RadixOtpInput, RadixSpinner } from '@/components/radix';
import { useLoginV3Flow } from './LoginV3FlowProvider';

export default function LoginV3AccessCodeCard() {
    const { state, onPasscodeValueChange, goNextInFlow, goBackInFlow } = useLoginV3Flow();
    const passcode = state.accessCode.digits;
    const employee = state.employee.selectedIndex !== null ? state.employee.list[state.employee.selectedIndex] : null;
    const isComplete = passcode.join('').length === 6;

    return (
        <RadixCard className="!p-0 border !border-[#E6E1D9] shadow-xl rounded-md bg-white/95 backdrop-blur-md overflow-hidden">
            <div className="relative bg-white p-6 sm:p-8 pb-4 text-center border-b border-[#F0EDE8]">
                <button
                    type="button"
                    onClick={goBackInFlow}
                    aria-label={t('Common.Back')}
                    className="absolute left-4 top-1/2 -translate-y-1/2 p-2 text-gray-400 hover:text-primary-500 transition-colors bg-transparent border-none outline-none cursor-pointer"
                >
                    <ArrowLeft size={20} />
                </button>
                {employee && (
                    <span className="w-12 h-12 sm:w-16 sm:h-16 rounded-full flex items-center justify-center overflow-hidden border-2 border-solid border-[#E6E1D9] mx-auto mb-3">
                        {employee.image ? (
                            <img src={employee.image} alt="" className="w-full h-full object-cover rounded-2xl" />
                        ) : (
                            (employee.name ?? '?').charAt(0)
                        )}
                    </span>
                )}
                <h1 className="text-xl sm:text-2xl font-bold text-gray-900 tracking-tight">{t('Common.OtpT')}</h1>
                {employee && (
                    <p className="text-gray-500 text-[11px] sm:text-sm mt-1 font-medium italic">
                        {t('Common.OTPD')} <span className="text-primary-600 font-bold">{employee.name ?? ''}</span>
                    </p>
                )}
            </div>

            <div className="p-6 sm:p-8">
                <div className="mb-8">
                    <RadixOtpInput
                        id="passcode-0"
                        name="passcode"
                        autoComplete="one-time-code"
                        value={passcode.join('')}
                        length={6}
                        fitContainer
                        onChange={onPasscodeValueChange}
                        inputClassName="!h-12 sm:!h-16 !text-xl !w-full !text-2xl !border-[#E6E1D9] focus:!border-primary-500 focus:!bg-white focus:!ring-4 focus:!ring-primary-500/10"
                    />
                </div>

                <RadixButton
                    variant="primary"
                    className="w-full !h-12 sm:!h-14 !rounded-xl !text-base font-bold shadow-lg shadow-primary-500/10 text-white"
                    onClick={() => void goNextInFlow()}
                    disabled={!isComplete || state.isLoading}
                >
                    {state.isLoading ? (
                        <div className="flex items-center gap-2">
                            <RadixSpinner size="sm" />
                            <span>{t('Common.Loading')}...</span>
                        </div>
                    ) : (
                        t('Common.LogNext')
                    )}
                </RadixButton>
            </div>
        </RadixCard>
    );
}
